export const Constants = {
    Characteristic: {
        RenderSettings: "encoway.renderSettings",
        ARPlacement: "arPlacement",
        ARScaleFactor: "arScaleFactor",
        ARRetentionTime: "retentionTime",
        IFC: "ifc",
        BflatGroups: "encoway.bflatGroups"
    },
    Extension: {
        ThreeDExporter: "3d-exporter",
        Rendering: "rendering",
        BflatExporter: "bflat-exporter",
        IFCHelper: "ifc-helper",
        CADHelper: "cad-helper"
    },
    PendingEvent: {
        ExportScene: "ExportScene",
        CreateDXF: "CreateDxf",
        CreateIFC: "CreateIfc",
        CreateSTEP: "CreateStep"
    }
}
